<template>
  <v-layout class="pa-0" style="flex-direction: column; height: 100%;">
    <v-flex>
      <TableComponent ref="viewer" :rowHeaders="rowHeaders" :columnHeaders="columnHeaders" :data="data" />
    </v-flex>
    <v-flex ref="footer" style="flex-grow: 0; flex-shrink: 0; background-color: #f5f5f5;">
      <v-item-group mandatory v-model="index" active-class="white--text">
        <v-item class="ma-0" v-for="(spreadsheetHeader, index) in spreadsheetHeaders" :key="`spreadsheetHeader-${index}`">
          <v-chip class="spreadsheetItem divider-right" slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" label small @click="toggle">{{ spreadsheetHeader.name }}</v-chip>
        </v-item>
      </v-item-group>
    </v-flex>
  </v-layout>
</template>

<script>
  import TableComponent from './Helpers/TableComponent'
  import helper from './Helpers/XLSX/XLSXParser'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  const reviewIngestionResults = createNamespacedHelpers('reviewingestionresults')

  export default {
    components: {
      TableComponent,
    },
    provide() {
      return { helper }
    },
    data() {
      return {
        data: [],
        isInitialized: false,
        index: 0,
        spreadsheetHeaders: [],
        rowHeaders: [],
        columnHeaders: [],
        heightPadding: 0,
      }
    },
    computed: {
      ...reviewIngestionResults.mapState(['goToLocation']),
    },
    watch: {
      index(value) {
        helper.setIndex(value)
        this.updateHeaders()
      },
      goToLocation(location) {
        if (location == null) {
          return
        }

        this.index = parseInt(helper.getLocationIndex(location))

        this.$nextTick(() => {
          this.$refs.viewer.scrollIntoCenter(location)
        })
      },
    },
    methods: {
      ...reviewIngestionResults.mapActions(['setGetData', 'setUndoChange', 'setGetChanges', 'setMetadataResetter', 'setGetMetadata', 'setGetMetadatumLocation']),
      updateHeaders() {
        this.rowHeaders = helper.getRowHeaders()
        this.columnHeaders = helper.getColumnHeaders()
      },
      updateData() {
        this.data = helper.getCurrentData()
        this.$refs.viewer.triggerUpdate()
      },
      async initialize(data) {
        helper.triggerUpdate = this.updateData
        helper.triggerMetadata = this.setGetMetadata
        helper.triggerUILogUpdates = this.$refs.viewer.updateLogClasses
        helper.parseData(data, this.$refs.viewer.getLogs)

        this.spreadsheetHeaders = helper.spreadsheetHeaders
        this.updateHeaders()
        this.updateData()

        this.heightPadding = this.$refs.footer.clientHeight        
        this.$refs.viewer.initialize()
      },
    },
    created() {
      this.setGetMetadata(() => helper.metadata)
      this.setGetMetadatumLocation((location) => helper.getCellMetadatum(location))
      this.setMetadataResetter(helper.undoHistory)
      this.setGetChanges(helper.undoHistory)
      this.setUndoChange((change) => helper.undoChange(change))
      this.setGetData(() => helper.unparseData())
    },
  }
</script>

<style>
  .spreadsheetItem .v-chip__content {
    cursor: pointer !important;
  }
</style>